import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
export const EP_QUESTION_ANSWER_CONTRIBUTORS_QUERY = gql `
  query EP_QuestionAnswerContributors(
    $questionID: ID!
  ) {
    ep_questionDetails(questionID: $questionID) {
      id
      answer {
        id
        data {
          answerHistory {
            author {
              id
              details {
                avatarURL
                firstName
                lastName
                userName
              }
            }
          }
        }
      }
    }
  }
`;
export function useQuestionAnswerContributorsQuery(options) {
    return useGQLQuery(EP_QUESTION_ANSWER_CONTRIBUTORS_QUERY, options);
}
